<template>
  <div>
    <input
      :type="type ? type : 'text'"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur')"
      :class="{ 'border-red': errors.has(name) }"
      :name="name"
      v-validate="rules"
      :placeholder="placeholder"
      :autocomplete="autocomplete ? autocomplete : ''"
    />

    <div class="text-sm mt-2 text-red" v-show="errors.has(name)" v-text="errors.first(name)"></div>
  </div>
</template>


<script>
//import attributesDe from '../bootstrap/validator/attributes/de'

export default {
  props: ['value', 'name', 'rules', 'type', 'autocomplete', 'placeholder'],
  inject: ['$validator'],

  data() {
    return {
      //name_as: this.placeholder ? this.placeholder : attributesDe[this.name]
    };
  },
};
</script>